import React from "react";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, Space, Tooltip } from "antd";
import { useDispatch } from "react-redux";
import { useClientAdd } from "hook/clients/useClient";
import { setDefaultClientSearch } from "store/user/(default)/client/default_client.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ClientAction = () => {
  // -------------------------- VAR -----------------------------
  const { handleOpenAdd } = useClientAdd();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleChange = (e) => {
    const value = e.target.value;
    dispatch(setDefaultClientSearch(value));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Space>
      <Input
        onChange={handleChange}
        style={{ minWidth: 250 }}
        placeholder="Tìm kiếm email khách hàng"
        suffix={<SearchOutlined style={{ color: "#aeaeae" }} />}
      />
      <Tooltip title="Thêm khách hàng mới">
        <Button onClick={handleOpenAdd} icon={<PlusOutlined />} />
      </Tooltip>
    </Space>
  );
};
export default ClientAction;
